import { render, staticRenderFns } from "./GvdDownloader.vue?vue&type=template&id=4add5cb9"
import script from "./GvdDownloader.vue?vue&type=script&lang=ts"
export * from "./GvdDownloader.vue?vue&type=script&lang=ts"
import style0 from "./GvdDownloader.vue?vue&type=style&index=0&id=4add5cb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports